import { createTheme } from '@mui/material/styles';

// A single accent color, reserved for calls-to-action and "this is interactive" affordances -
// everything else stays neutral so the accent (and the semantic price-trend colors) keep meaning.
const ACCENT = '#f0a202';

export const theme = createTheme({
  palette: {
    primary: { main: '#0f1b2d', light: '#24374f', dark: '#070f1a', contrastText: '#ffffff' },
    secondary: { main: ACCENT, contrastText: '#0f1b2d' },
    success: { main: '#15803d' }, // price trending down - good for a buyer
    error: { main: '#dc2626' }, // price trending up
    background: { default: '#f6f7f9', paper: '#ffffff' },
    text: { primary: '#101828', secondary: '#5b6472' },
    divider: '#e4e7ec',
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    h1: { fontWeight: 800, letterSpacing: '-0.02em' },
    h2: { fontWeight: 800, letterSpacing: '-0.02em' },
    h3: { fontWeight: 700, letterSpacing: '-0.01em' },
    h4: { fontWeight: 700, letterSpacing: '-0.01em' },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    button: { fontWeight: 600, textTransform: 'none' },
  },
  components: {
    MuiCard: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: { border: '1px solid #e4e7ec', backgroundImage: 'none' },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 10 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600 },
      },
    },
    MuiAppBar: {
      defaultProps: { elevation: 0 },
    },
  },
});
